import { Icon } from "@blueprintjs/core";

import { SUBTEXT_COLOR } from "@/css/constants";

export function CalendarIcon() {
  return (
    <Icon
      icon="calendar"
      css={{
        position: "absolute",
        top: 12,
        left: 10,
        zIndex: 99,
        color: SUBTEXT_COLOR,
      }}
    />
  );
}
